import React from 'react';
import OwnerList from './owner-list';
import BackButton from './back-button';
import ActionArea from './action-area';
import Tooltip from './tooltip';
import Spinner from './spinner';

const AddOwners = (props) => {
  const { actions, history, isInReview, onboarding } = props;
  const { processingSubmit, hasCompletedReview } = onboarding;
  const previousRoute = isInReview
    ? '/patientsolutions/enroll/review'
    : '/patientsolutions/enroll/ownership';

  const saveOwners = (e) => {
    const {
      owners,
      hasIncompleteOwner
    } = props;

    actions.submitOwnershipInfo(owners, hasIncompleteOwner)
      .then((result) => {
        if (result && result.capAlreadyReview) { return; }
        
        actions.setPreviousRoute('/patientsolutions/enroll/add-owners');

        const route = isInReview
          ? '/patientsolutions/enroll/review'
          : '/patientsolutions/enroll/ownership/significant-owner';

        history.push(route);
      })
      .catch(({ response }) => {
        const { status, data } = response;

        if (status && status !== 400) {
          window.location.href = '/patientsolutions/enroll/error';
        }

        if (data && data.redirectTo) {
          window.location.href = data.redirectTo;
        }
      });
  };

  const buttonProps = {
    ...props,
    onSubmit: saveOwners,
    className: 'button-submit-next',
    'aria-label': 'practice submit button'
  };

  if (hasCompletedReview) {
    buttonProps.disabled = true;
  }

  return <section className="add-owners-section">
    <BackButton {...props} previousRoute={previousRoute} />
    <h1 className='section-title'>Let us know who owns 25% or more of the practice</h1>
    <p className='section-desc'>We&apos;re required by law to obtain and verify the personal information of each individual who directly or indirectly own 25% or more of your practice. We value your information and anything you share will be strictly used for verification purposes only.</p>
    <Tooltip
      tooltipActiveInMs={5000}
      tooltipMsg='No need to worry, we know how difficult it can be to track everything down. If you need more time, we have your registration saved so you can pick up right where you left off.'
    >What if I don&apos;t have all this information on hand?</Tooltip>
    <OwnerList { ...props } />
    <p className='legal-disclosure'>
      To help the government fight the funding of terrorism and money laundering activities, federal regulations require all financial institutions to obtain, verify and record information that identifies each person who opens an account. What this means for you: When you open an account, we will ask your name, address, date of birth and other information that will allow us to identify you.
    </p>
    <ActionArea {...buttonProps} />

    { processingSubmit && <Spinner processingSubmit={processingSubmit}/> }

  </section>;
};

export default AddOwners;

